var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('th',{staticClass:"text-left"},[_c('v-btn',{staticClass:"text-left pl-0 pr-0 ml-0 mr-0",attrs:{"block":"","text":""},on:{"click":function($event){return _vm.setNewOrdering()}}},[_vm._t("default"),_c('v-spacer'),_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.icon))])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }